// client/components/ui/MobileActionBar.jsx
import React from "react";
import { twMerge } from "tailwind-merge";
import {
  mobileActionBarInnerClassName,
  mobileSafeAreaBottomClassName,
} from "../../design/tokens.js";

/**
 * MobileActionBar — sticky Footer-Aktionen nur unter md.
 * Desktop: nicht gerendert (md:hidden). Ab md: Seiten nutzen weiterhin inline/rechtsbündige Buttons.
 */
export default function MobileActionBar({
  children,
  className = "",
  innerClassName = "",
  /** Negative Margin für Einbettung in gepaddete Formulare (z. B. -mx-4 -mb-4) */
  bleedClassName = "-mx-4 -mb-4 px-4",
}) {
  return (
    <div
      className={twMerge(
        "md:hidden sticky bottom-0 inset-x-0 z-10",
        mobileSafeAreaBottomClassName,
        bleedClassName,
        className,
      )}
    >
      <div className={twMerge(mobileActionBarInnerClassName, innerClassName)}>{children}</div>
    </div>
  );
}
